import { createRouter, createWebHistory } from "vue-router";
import store from './store/index.js';
import { DIRECTORY_MODE } from './config/features.js';

//Not found
const TheNotFound = () => import('./pages/TheNotFound.vue');

//---- Public Landing Page
const LandingPage = () => import('./pages/landing/LandingPage.vue');

//Auth
const Login = () => import("./pages/auth/LoginUser.vue");
const SignUp = () => import("./pages/auth/SignupUser.vue");

//Student dashboard
const TheDashboardStudents = () => import('./components/dashboard/TheDashboardStudents.vue');

//pages
//----School
//import ListSchool from "./pages/school/ListSchools.vue";
const DetailSchool = () => import('./pages/school/DetailSchool.vue');


//----Students
const ListStudent = () => import('./pages/school/students/ListStudents.vue');
const NewStudent = () => import('./pages/school/students/NewStudent.vue');
const DetailStudent = () => import('./pages/school/students/DetailStudent.vue');


//----Subscriptions
const ListSubscription = () => import('./pages/school/subscriptions/ListSubscriptions.vue');
const NewSubscription = () => import('./pages/school/subscriptions/NewSubscription.vue');
const RenewSubscription = () => import('./pages/school/subscriptions/RenewSubscription.vue');

//----Types of dance
const ListTypeDance = () => import('./pages/school/types-dance/ListTypeDance.vue');
const NewTypeDance = () => import('./pages/school/types-dance/NewTypeDance.vue');
const EditTypeDance = () => import('./pages/school/types-dance/EditTypeDance.vue');


//---- Package
const ListPackages = () => import('./pages/school/packages/ListPackages.vue');
const NewPackage = () => import('./pages/school/packages/NewPackage.vue');
const EditPackage = () => import('./pages/school/packages/EditPackage.vue');

//---- Package
const ScheduleList = () => import('./pages/school/schedule/ListSchedule.vue');
const ScheduleDetail = () => import('./pages/school/schedule/DetailSchedule.vue');

//pages
//----Students
const homePage = () => import('./pages/dashboard-user/home/HomePage.vue');
const accountPage = () => import('./pages/dashboard-user/account/AccountPage.vue');
const StudentClassDetail = () => import('./pages/dashboard-user/class-detail/StudentClassDetail.vue');

//---- Verify Email
const VerifyEmail = () => import('./pages/auth/verify-email/VerifyEmail.vue');

//---- Set Password
const SetPassword = () => import('./pages/auth/set-password/SetPassword.vue');

//---- Choose School (multi-school owner/assistant)
const ChooseSchool = () => import('./pages/auth/ChooseSchool.vue');

//---- Feedback
const FeedbackPage = () => import('./pages/feedback/FeedbackPage.vue');

//---- Discover (map of schools)
const DiscoverPage = () => import('./pages/discover/DiscoverPage.vue');

//---- Free Trial
const TrialClaimPage = () => import('./pages/trial/TrialClaimPage.vue');

//---- Visit School (public school profile)
const VisitSchoolPage = () => import('./pages/visit/VisitSchoolPage.vue');

//---- School Check-In QR
const CheckinPage = () => import('./pages/checkin/CheckinPage.vue');

//---- Public dance directory
const PublicLayout = () => import('./pages/directory/PublicLayout.vue');
const HomePublicPage = () => import('./pages/directory/HomePublicPage.vue');
const ExplorePage = () => import('./pages/directory/ExplorePage.vue');
const SchoolPublicPage = () => import('./pages/directory/SchoolPublicPage.vue');
const EventPublicPage = () => import('./pages/directory/EventPublicPage.vue');
const OrganizerPublicPage = () => import('./pages/directory/OrganizerPublicPage.vue');

//---- Directory admin (superadmin)
const AdminLayout = () => import('./pages/admin/AdminLayout.vue');
const AdminSchoolsPage = () => import('./pages/admin/AdminSchoolsPage.vue');
const AdminSchoolEditPage = () => import('./pages/admin/AdminSchoolEditPage.vue');
const AdminEventsPage = () => import('./pages/admin/AdminEventsPage.vue');
const AdminOrganizersPage = () => import('./pages/admin/AdminOrganizersPage.vue');
const AdminGenresPage = () => import('./pages/admin/AdminGenresPage.vue');
const AdminImportPage = () => import('./pages/admin/AdminImportPage.vue');
const AdminInboxPage = () => import('./pages/admin/AdminInboxPage.vue');
const AdminStatsPage = () => import('./pages/admin/AdminStatsPage.vue');

//---- Legal (Privacy Policy / Terms of Service)
const PrivacyPolicyPage = () => import('./pages/legal/PrivacyPolicyPage.vue');
const TermsOfServicePage = () => import('./pages/legal/TermsOfServicePage.vue');

// Public directory pages (no login). In directory mode the events home page
// is "/"; otherwise "/" stays the marketing landing page and the directory
// home lives at "/directory".
const directoryRoutes = {
    path: '/',
    component: PublicLayout,
    children: [
        { path: DIRECTORY_MODE ? '' : 'directory', name: 'public-home', component: HomePublicPage },
        { path: 'explore', name: 'explore', component: ExplorePage, meta: { hideFooter: true } },
        // Same page as /explore, opened on the events tab.
        { path: 'events', name: 'public-events', component: ExplorePage, meta: { hideFooter: true } },
        { path: 'events/:eventId', name: 'public-event', component: EventPublicPage, props: true },
        { path: 'schools/:schoolId', name: 'public-school', component: SchoolPublicPage, props: true },
        { path: 'organizers/:organizerId', name: 'public-organizer', component: OrganizerPublicPage, props: true },
    ],
};

const adminRoutes = {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true, requiresSuperadmin: true },
    children: [
        { path: '', redirect: { name: 'admin-schools' } },
        { path: 'schools', name: 'admin-schools', component: AdminSchoolsPage },
        { path: 'schools/:schoolId', name: 'admin-school-edit', component: AdminSchoolEditPage, props: true },
        { path: 'events', name: 'admin-events', component: AdminEventsPage },
        { path: 'organizers', name: 'admin-organizers', component: AdminOrganizersPage },
        { path: 'genres', name: 'admin-genres', component: AdminGenresPage },
        { path: 'import', name: 'admin-import', component: AdminImportPage },
        { path: 'inbox', name: 'admin-inbox', component: AdminInboxPage },
        { path: 'stats', name: 'admin-stats', component: AdminStatsPage },
    ],
};

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition;
        // Filter changes on the same page (query only) keep the scroll position.
        if (to.path === from.path) return false;
        return { top: 0 };
    },
    routes: [
        ...(DIRECTORY_MODE ? [] : [{
            path: '/',
            name: 'landing',
            component: LandingPage,
            meta: {
                publicLanding: true
            },
        }]),
        directoryRoutes,
        adminRoutes,
        {
            path: '/login',
            name: 'login',
            meta: {
                requiresUnauthenticated: true  
            },
            component: Login
        },
        {
            path: '/signup',
            name: 'signup',
            meta: {
                requiresUnauthenticated: true,
                managementFeature: true
            },
            component: SignUp
        },
        {
            path: '/verify-email',
            name: 'verify-email',
            component: VerifyEmail,
            meta: { managementFeature: true },
        },
        {
            path: '/set-password',
            name: 'set-password',
            component: SetPassword,
            meta: { managementFeature: true },
        },
        {
            path: '/choose-school',
            name: 'choose-school',
            component: ChooseSchool,
            meta: {
                requiresAuth: true,
                requiresSchoolChoice: true,
                managementFeature: true
            },
        },
        {
            path: '/home',
            name: 'dashboard-user',
            meta: {
                requiresAuth: true,
                requiresSchool: true,
                managementFeature: true
            },
            component: TheDashboardStudents,
            children: [
                {
                    path: '',
                    name: 'home',
                    component: homePage
                },
                {
                    path: 'account',
                    name: 'account-user',
                    component: accountPage
                },
                {
                    path: 'class-detail/:id',
                    name: 'student-class-detail',
                    component: StudentClassDetail,
                    props: true
                },
                {
                    path: 'detail',
                    name: 'detail-school',
                    component: DetailSchool
                },
                {
                    path: 'students',
                    name: 'list-students',
                    component: ListStudent,
                },
                {
                    path: 'new-student',
                    name: 'new-student',
                    component: NewStudent,
                },
                {
                    path: '/detail-student',
                    name: 'detail-student',
                    component: DetailStudent,
                },
                {
                    path: 'subscriptions',
                    name: 'list-subscriptions',
                    component: ListSubscription,
                },
                {
                    path: 'new-subscription',
                    name: 'new-subscription',
                    component: NewSubscription,
                },
                {
                    path: 'renew-subscription',
                    name: 'renew-subscription',
                    component: RenewSubscription,
                },
                {
                    path: 'type-dance',
                    name: 'type-dance',
                    component: ListTypeDance
                },
                {
                    path: 'new-type-dance',
                    name: 'new-type-dance',
                    component: NewTypeDance
                },
                {
                    path: 'edit-type-dance',
                    name: 'edit-type-dance',
                    component: EditTypeDance
                },
                {
                    path: 'packages',
                    name: 'packages',
                    component: ListPackages
                },
                {
                    path: 'new-package',
                    name: 'new-package',
                    component: NewPackage
                },
                {
                    path: 'edit-package/:packageId',
                    name: 'edit-package',
                    component: EditPackage,
                    props: true
                },
                {
                    path: 'schedule',
                    name: 'schedule',
                    component: ScheduleList
                },
                {
                    path: 'schedule-detail/:id',
                    name: 'schedule-detail',
                    component: ScheduleDetail,
                    props: true
                },
                {
                    path: 'feedback',
                    name: 'feedback',
                    component: FeedbackPage,
                },
                {
                    path: 'discover',
                    name: 'discover',
                    component: DiscoverPage,
                    // Guests can browse the map without an account; the parent
                    // route's requiresAuth is still merged into meta, so the
                    // guard checks guestAllowed before redirecting to login.
                    meta: { guestAllowed: true },
                },
                {
                    path: '/:notFound(.*)*',
                    component: TheNotFound
                }
            ]
        },
        {
            path: '/trial/:schoolId',
            name: 'trial-claim',
            meta: { managementFeature: true },
            component: TrialClaimPage,
            props: true,
        },
        {
            path: '/trial/:schoolId/style/:styleId',
            name: 'trial-claim-style',
            meta: { managementFeature: true },
            component: TrialClaimPage,
            props: true,
        },
        {
            path: '/trial/:schoolId/package/:packageId',
            name: 'trial-claim-package',
            meta: { managementFeature: true },
            component: TrialClaimPage,
            props: true,
        },
        {
            path: '/visit/:schoolId',
            name: 'visit-school',
            meta: { managementFeature: true },
            component: VisitSchoolPage,
            props: true,
        },
        {
            path: '/checkin/:schoolId',
            name: 'checkin',
            meta: { managementFeature: true },
            component: CheckinPage,
            props: true,
        },
        {
            path: '/privacy-policy',
            name: 'privacy-policy',
            component: PrivacyPolicyPage,
        },
        {
            path: '/terms-of-service',
            name: 'terms-of-service',
            component: TermsOfServicePage,
        },
        {
            path: '/:notFound(.*)',
            component: TheNotFound
        }
    ]
});

let appInitialized = false;

router.beforeEach(async (to, _from, next) => {
    try {
        if (!appInitialized) {
            await store.dispatch('auth/checkAuthLocalStorage');
            appInitialized = true;
        }
        const isAuthenticated = store.getters['auth/isAuthenticated'];
        const isSuperadmin = store.getters['auth/isSuperadmin'];
        // Directory mode hides the school-management app (dashboard, signup,
        // trials, check-in...). Superadmins land on the directory admin panel.
        if (DIRECTORY_MODE && to.matched.some((record) => record.meta.managementFeature)) {
            next(isAuthenticated && isSuperadmin ? { name: 'admin-schools' } : { name: 'public-home' });
            return;
        }
        if (to.meta.requiresSuperadmin && isAuthenticated && !isSuperadmin) {
            next(DIRECTORY_MODE ? { name: 'public-home' } : { name: 'home' });
            return;
        }
        if (to.meta.requiresAuth && !to.meta.guestAllowed && !isAuthenticated) {
            next('/login');
            return;
        }
        if (to.meta.requiresUnauthenticated && isAuthenticated) {
            next({ name: 'home' });
            return;
        }
        if (to.meta.publicLanding && isAuthenticated) {
            next({ name: 'home' });
            return;
        }
        if (to.meta.requiresSchoolChoice) {
            next();
            return;
        }
        if (to.meta.requiresSchool && isAuthenticated && (store.getters['auth/isOwner'] || store.getters['auth/isAssistant'])) {
            const schools = store.getters['school/getSchools'] || [];
            const currentSchoolId = store.getters['school/getCurrentSchoolId'];
            if (schools.length > 1 && !currentSchoolId) {
                next({ name: 'choose-school' });
                return;
            }
        }
        next();
    } catch (error) {
        console.log("Error: ", error);
        next();
    }
});

export default router;